import React from "react"

interface SegToggleProps<T extends string> {
  options: { key: T; label: string }[]
  active: T
  onChange: (key: T) => void
}

function SegToggle<T extends string>({
  options,
  active,
  onChange,
}: SegToggleProps<T>) {
  return (
    <div className="b-portfolio-summary-seg">
      {options.map((opt) => (
        <button
          key={opt.key}
          type="button"
          className={`b-portfolio-summary-seg-btn${
            opt.key === active ? " active" : ""
          }`}
          onClick={() => onChange(opt.key)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  )
}

export default SegToggle
